import { useIsMobileVariant } from '@dhl-ui/components'
import { isFeatureEnabled } from '~/config/index.js'
import { useGetGuidedTours } from './useGetGuidedTours.js'

export const useGuidedTourInteraction = () => {
  const { getGuidedTours } = useGetGuidedTours()
  const isMobile = useIsMobileVariant()

  return async (): Promise<boolean> => {
    const tours = await getGuidedTours()

    return tours.length > 0 && isFeatureEnabled('interaction.guidedTour') && isMobile
  }
}
